import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { CollaborativeBillSplitItemResponseDto } from '@features/client/models/public-bill-split-collaboration-models';
import { ParticipantItemSelectionDraft } from '@features/client/models/participant-selection.models';

@Component({
  selector: 'app-participant-submitted-item-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './participant-submitted-item-card.html',
})
export class ParticipantSubmittedItemCardComponent {
  item = input.required<CollaborativeBillSplitItemResponseDto>();
  draft = input.required<ParticipantItemSelectionDraft>();

  readonly label = computed(() => {
    const draft = this.draft();

    if (draft.mode === 'BY_QUANTITY') {
      return `Consumiste ${draft.quantity ?? 1} unidad${(draft.quantity ?? 1) === 1 ? '' : 'es'}`;
    }

    if (draft.mode === 'EQUAL_SHARE') {
      if (draft.equalShareScope === 'FULL_ITEM') {
        return 'Lo compartiste completo';
      }

      return `Compartiste ${draft.equalShareQuantity ?? 1} unidad${(draft.equalShareQuantity ?? 1) === 1 ? '' : 'es'}`;
    }

    if (draft.mode === 'UNRESOLVED') {
      if ((draft.suggestedGroups ?? []).length) {
        return 'Dejaste una sugerencia para dividirlo';
      }

      return 'Lo marcaste para que el anfitrión lo resuelva';
    }

    return 'Marcado como consumido';
  });

  readonly groupsLabel = computed(() => {
    const groups = this.draft().suggestedGroups ?? [];

    if (!groups.length) return null;

    return groups
      .map((group) => {
        const type = group.participation === 'INDIVIDUAL' ? 'individual' : 'compartida';

        return `${group.size} ${type}`;
      })
      .join(' · ');
  });
}
